import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bolcom.webp';
import screenshot_target from '../../../images/letterfunnel/jasperschulte.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jasper Schulte"
      firstname="Jasper"
      companyname="Bol.com"
      competition="Amazon en Coolblue"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jasperschulte.js